module.exports = "/newsfeed/directives/newsfeedMemberGroup-82508a.html";